import gql from 'graphql-tag';

export const CREATE_LOCATION = gql`
  mutation createLocationMutation($input: CreateLocationInput!) {
    createLocation(input: $input) {
      id
      name
      addressObj {
        id
        region
        street
        city
        postcode
      }
      coordinates
      accessHours
      directions
      requiresAccessPass
      requiresSignIn
      signInInstructions
      accessPassDetails
      requiredEquipment
      machines {
        id
      }
      client {
        id
      }
      person {
        id
      }
      secondaryPerson {
        id
      }
    }
  }
`;
